module.exports = __webpack_public_path__ + "img/sponsor-logo.32da02b8.svg";